window.addEventListener('message', function(event) {
    var type = event.data.type;
    var iframeId = event.data.iframeId;
    var height = event.data.height;
    var ALLOWED_ORIGINS = ['https://embed.fireplace.yahoo.com'];

    if (ALLOWED_ORIGINS.includes(event.origin) && type === 'embed-size' && iframeId && height) {
        console.info('Iframe "' + iframeId + ' height updated to ' + height);
        document.getElementById(iframeId).setAttribute('height', height);
    }
}, false);